import './global-loading-indicator.component.scss';

export default {
  template: require('./global-loading-indicator.component.html'),
  controller: function ($scope, $gl) {
    'ngInject';

    const self = $scope.$ctrl;

    self.showLoading = false;
    const HANDLER_ID = 'global-loading-indicator-id';

    const actions = {
      show: () => self.showLoading = true,
      hide: () => self.showLoading = false
    }

    $gl.registerHandler(HANDLER_ID, actions);

    $scope.$on('$destroy', () => {
      $gl.unregisterHandler(HANDLER_ID, actions);
    });

  }
};
